import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoadingComponent } from '@scandium-oy/ngx-scandium';
import { Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { IScheduleUser } from 'src/app/models/site.model';
import { SubItem } from 'src/app/models/sub-item.model';
import { RoomTicket } from 'src/app/models/ticket.model';
import { TranslateTicketPipe } from 'src/app/pipes/ticket-translate/ticket-translate.pipe';
import { WorkerTicketsService } from 'src/app/services/worker-tickets.service';

@Component({
  selector: 'app-user-tickets-schedule-dialog',
  templateUrl: './user-tickets.dialog.html',
  styleUrls: ['./user-tickets.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    CommonModule,
    MainDialogComponent,
    NoResultsComponent,
    TranslateTicketPipe,
    LoadingComponent,
  ],
})
export class UserTicketsTodayDialogComponent implements OnInit {
  private workerTicketsService = inject(WorkerTicketsService);
  private _modal = inject(ModalController);

  date = input<Date>();
  site = input<SubItem>();
  user = input<(IScheduleUser & { name?: string })>();

  loading = signal(true);

  tickets$: Observable<(RoomTicket & {
    roomName: string;
  })[]>;

  ngOnInit(): void {
    this.tickets$ = this.workerTicketsService.getUserTicketsByDate(this.date(), this.user().guid, this.site()).pipe(
      map((tickets) => tickets.map((ticket) => this.workerTicketsService.withMediaPreview(ticket))),
      tap(() => this.loading.set(false)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  onTicket(roomTicket: RoomTicket) {
    const room = roomTicket.room ?? roomTicket.parent?.room;
    const siteGuid = roomTicket.site?.guid ?? roomTicket.parent?.site;
    if (room == null || siteGuid == null) {
      return;
    }
    this.workerTicketsService.onRoomTicket(roomTicket, siteGuid, room, roomTicket.parent);
  }

  dismiss() {
    this._modal.dismiss();
  }
}
